import React from 'react';
import List from './List';

//No longer just 2 days, is variable
const sla_2_working_days_at_allocated = item =>
  item &&
  item.sla_2_working_days_at_allocated && (
    <span>
      <span
        className="fa fa-exclamation-triangle mr-2"
        style={{ color: '#ffa900' }}
      />
      SLA expired
    </span>
  );

//No longer just 2 days, variable
const sla_2_working_days_filter = ({ filters, setFilters }) => {
  return (
    <label className="row ml-2 mt-2 mr-1">
      <div className="mt-auto mb-auto">Show only orders breaching SLA?:</div>
      <input
        className="ml-2 mt-1"
        type="checkbox"
        onClick={e => {
          setFilters({
            ...filters,
            order_last_updated_working_days: e.target.checked ? true : null,
            order_status_only: e.target.checked ? 20 : null,
          });
        }}
      />
    </label>
  );
};

const AssignedList = ({ ...props }) => (
  <List
    url="orders?order_status=assigned"
    title="Assigned Orders"
    canAssign={true}
    canManage={!props.readOnly}
    canView={true}
    icon={sla_2_working_days_at_allocated}
    jobIcon={sla_2_working_days_at_allocated}
    filterUI={[sla_2_working_days_filter]}
    {...props}
  />
);

export default AssignedList;



// WEBPACK FOOTER //
// ./src/pages/Orders/AssignedList.jsx